var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleEvent',{attrs:{"match":_vm.match}})
}
var staticRenderFns = []

export { render, staticRenderFns }